// @flow

import { type OutgoingPayment } from '../outgoing-payment/types';
import type {UserInputValues} from '@tectonics/prs/user-input-values';

export async function cryptocurrencyOutgoingPaymentMapper(userInputValues: UserInputValues): Promise<$Shape<OutgoingPayment>> {
  return {
    payment_type: 'cryptocurrency',
    payment_type_code: userInputValues['selectedCryptocurrency'],
    birth_date: formatDate(userInputValues['customerBirthdate']),
    metadata: {
      selected_protocol: userInputValues['selectedProtocol'],
    },
  };
}

// Endpoint Pay /ws/confirm expects birth_date in DD/MM/YYYY format
function formatDate(date: string): string {
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
}
